const required = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
] as const

const missing = required.filter((k) => !import.meta.env[k])
if (missing.length > 0) {
  throw new Error(
    `Missing required environment variables:\n  ${missing.join('\n  ')}\n` +
      `Create a .env.local file — see README.md for required values.`,
  )
}

export const env = {
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY!,
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN!,
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID!,
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET!,
  firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID!,
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID!,
  useEmulator: import.meta.env.VITE_USE_EMULATOR === 'true',
  assistantMock: import.meta.env.VITE_ASSISTANT_MOCK === 'true',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE ?? '',
} as const
